import { detectOS } from 'packages/lib/utils/detect-os';

export const isMacDevice = detectOS()?.toLowerCase()?.includes('mac');
export const cmdCtrlSymbol = isMacDevice ? '⌘' : 'Ctrl';
